import { render, staticRenderFns } from "./communityDataToIot.vue?vue&type=template&id=61b59c5d"
import script from "./communityDataToIot.vue?vue&type=script&lang=js"
export * from "./communityDataToIot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports